export const removeFromLocalStorage = name => {
	localStorage.removeItem(name)
}
